import type { LeadStatus } from "../types/api";

export const statusLabels: Record<LeadStatus, string> = {
  CAPTURED: "Lead capturado",
  CONTACTED: "Em contato",
  APPOINTMENT_SCHEDULED: "Consulta agendada",
  PROCEDURE_COMPLETED: "Procedimento realizado",
  CONVERTED: "Convertido",
  POST_SERVICE: "Pós-atendimento",
  APPOINTMENT_CANCELLED: "Consulta cancelada",
  LOST: "Perdido",
};

export const partnerTypeLabels: Record<string, string> = {
  PERSONAL_TRAINER: "Personal trainer",
  INFLUENCER: "Influenciador(a)",
  PROFESSIONAL: "Profissional parceiro",
  OTHER: "Outro",
};

export function formatDate(value?: string): string {
  if (!value) return "—";
  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat("pt-BR").format(value);
}

export function formatPercent(value: number): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "percent",
    maximumFractionDigits: 1,
  }).format(value);
}
